import React from 'react';
import styles from './OptIn.css';
import { Button } from 'react-toolbox/lib/button';

const OptIn = ({
  accepted,
  declined,
  error,
  onAccept,
  onDecline,
  onUndo,
  optIn,
}) =>
  <div className={styles.container}>
    {optIn.logoUri
      ? <img
          className={styles.logo}
          src={optIn.logoUri}
          alt={optIn.optInTitle}
        />
      : <h2 className={styles.title}>{`${optIn.optInTitle}${optIn.required
          ? ''
          : ' (Optional)'}`}</h2>}
    <p className={error ? styles.descriptionError : styles.description}>
      {optIn.optInDescription}
    </p>
    {!accepted &&
      !declined &&
      <div className={styles.buttonRow}>
        {optIn.acceptDescription &&
          <p className={styles.acceptDescription}>
            {optIn.acceptDescription}
          </p>}
        <Button
          className={styles.acceptButton}
          // label={optIn.acceptTitle}
          label="View Terms"
          raised
          primary
          onClick={onAccept}
        />
        {optIn.declineDescription &&
          <p className={styles.declineDescription}>
            {optIn.declineDescription}
          </p>}
        <Button
          className={styles.declineButton}
          label={optIn.declineTitle}
          onClick={onDecline}
        />
      </div>}
    {accepted &&
      <div className={styles.buttonRow}>
        <Button
          className={styles.acceptedButton}
          icon="check"
          label="Accepted"
          disabled
        />
        <Button label="Undo" onClick={onUndo} />
      </div>}
    {declined &&
      <div className={styles.buttonRow}>
        <Button
          className={styles.declinedButton}
          icon="not_interested"
          label="Declined"
          disabled
        />
        <Button label="Undo" onClick={onUndo} />
      </div>}
    {error &&
      <div className={styles.errorRow}>
        <p>
          {error}
        </p>
      </div>}
  </div>;

export default OptIn;



// WEBPACK FOOTER //
// ./src/options/components/OptIn.js